// src/components/pages/message/timecapsule/components/SmsInviteDialog.js
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

export default function SmsInviteDialog({ open, onClose, onSend }) {
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      onClose={(e, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
        onClose?.();
      }}
      aria-labelledby="sms-invite-title"
    >
      <DialogTitle id="sms-invite-title">Invite via SMS</DialogTitle>
      <DialogContent>
        <DialogContentText>
          We noticed some phone numbers aren’t registered on Inssa yet. Send them a quick SMS so
          they know you’ve buried a time capsule just for them.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button
          variant="contained"
          onClick={onSend}
          fullWidth
          sx={(theme) => ({
            backgroundColor: theme.colors.inssa,
            color: theme.colors.white,
            padding: "14px 30px",
            fontWeight: 700,
            fontSize: "1rem",
          })}
        >
          Send Sms Invite
        </Button>
      </DialogActions>
    </Dialog>
  );
}
